import layout from '@/components/layout/layout'
import {localLanguageVal} from "@/utils/autoScale";
let localLanguage=localLanguageVal()
const tech = {
  path: '',
  name: 'tech',
  redirect: '',
  component: layout,
  children: [{
    path: localLanguage+'/tech/:tab',
    redirect: '',
      name: 'tech',
    component: () => import('@/views/tech/index')
  }]
}

export default tech
